import { Timestamp } from "firebase/firestore";

export enum RequestType {
    WWCC = "WWCC",
    Interview = "INTR",
}

export enum RequestStatus {
    Pending = "PEN",
    Approved = "APR",
    Rejected = "REJ",
    None = "NON",
}

export type RequestSchema = {
    UserId: string,
    Date: Timestamp,
    Status: RequestStatus,
    Type: RequestType,
}

export type InterviewRequestSchema = RequestSchema

export type WWCCRequestSchema = RequestSchema & {
    WWCC: string,
}

const nameofRequestSchemaUserId = "UserId";
const nameofRequestSchemaDate = "Date";
const nameofRequestSchemaStatus = "Status";
const nameofRequestSchemaType = "Type";
const nameofRequestSchemaCollection = "Request";

const nameofWWCCRequestSchemaWWCC = "WWCC";

export {
    nameofRequestSchemaUserId,
    nameofRequestSchemaDate,
    nameofRequestSchemaStatus,
    nameofRequestSchemaType,
    nameofRequestSchemaCollection,
    nameofWWCCRequestSchemaWWCC,
};

export type WWCCRequestView = WWCCRequestSchema & {
    Id: string,
};

export type InterviewRequestView = InterviewRequestSchema & {
    Id: string,
};

export type RequestView = RequestSchema & {
    Id: string,
};